import DataDog from './dataDog.js'
import FakeDataDog from './fakeDataDog.js'

export const createDataDog = (options) => {
  return options.config.features.dataDogFrontendDisabled ? new FakeDataDog(options) : new DataDog(options)
}
